'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;



//////////////////
// WEBPACK FOOTER
// C:/GH/1106/advice.noa.origination/~/get-proto/Object.getPrototypeOf.js
// module id = 256
// module chunks = 0